var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterDrops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.8264C12 15.6478 9.76142 17.9349 7 17.9349C4.23858 17.9349 2 15.6478 2 12.8264C2 10.6968 4.84873 7.70738 6.24566 6.36947C6.67386 5.95936 7.32614 5.95936 7.75434 6.36947C9.15127 7.70738 12 10.6968 12 12.8264Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.18541C19 7.59608 17.8807 8.73965 16.5 8.73965C15.1193 8.73965 14 7.59608 14 6.18541C14 5.28398 15.0208 4.07441 15.7579 3.3186C16.1721 2.8938 16.8279 2.8938 17.2421 3.3186C17.9792 4.07441 19 5.28398 19 6.18541Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17.5943C22 19.4752 20.433 21 18.5 21C16.567 21 15 19.4752 15 17.5943C15 16.2662 16.7452 14.4364 17.7709 13.4756C18.1875 13.0853 18.8125 13.0853 19.2291 13.4756C20.2548 14.4364 22 16.2662 22 17.5943Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDrops);
export default __webpack_public_path__ + "static/media/water-drops.1df53d1913e1c41868ce7b0279536680.svg";
export { ForwardRef as ReactComponent };